<template>
  <div>Redirecionando para o PDF...</div>
</template>

<script>
export default {
  mounted() {
    window.location.href = 'https://cafedasorte.pt/storage/app/media/Termos_e_condicoes_de_adesao_a_campanha_cafe_da_sorte.pdf';
  }
}
</script>
